"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    enableDisableInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_EnableDisableInboxRule',
            customData: function (inboxRuleId, shouldBeEnabled) { return [
                inboxRuleId,
                shouldBeEnabled,
            ]; },
        },
    },
    generateInboxRulesDiagnosticReportDatapoint: {
        datapoint: { name: 'TnS_GenerateInboxRulesDiagnosticReport' },
    },
    getInboxRulesDatapoint: { datapoint: { name: 'TnS_GetInboxRules' } },
    numInboxRules: {
        datapoint: {
            name: 'TnS_NumInboxRules',
            customData: function (inboxRuleCollectionLength) { return [inboxRuleCollectionLength]; },
        },
    },
    removeInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_RemoveInboxRule',
            customData: function (inboxRuleId) { return [inboxRuleId]; },
        },
    },
    setInboxRulesDatapoint: { datapoint: { name: 'TnS_SetInboxRules' } },
    inboxRuleInformationDatapoint: {
        datapoint: {
            name: 'TnS_InboxRuleInformation',
            customData: function (inboxRuleInformation, actionSource, numConditionalClauses, numActionClauses, numExceptionClauses) { return [
                inboxRuleInformation,
                actionSource,
                numConditionalClauses,
                numActionClauses,
                numExceptionClauses,
            ]; },
        },
    },
    addPhraseToClauseDatapoint: {
        datapoint: {
            name: 'TnS_AddPhraseToClause',
            customData: function (clauseId, phraseToAdd, actionSource) { return [phraseToAdd.indexOf(' ') !== -1, actionSource]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/datapoints.js
// module id = 2896
// module chunks = 2